var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectAcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.625 7.10938H37.6562V32.8906H10.625V7.10938ZM2.34375 7.10938H8.20312V32.8906H2.34375V7.10938ZM0 5.70312V34.2969C0 34.7499 0.503438 35.3125 1.17188 35.3125H38.8281C39.4966 35.3125 40 34.7499 40 34.2969V5.70312C40 5.25008 39.4966 4.6875 38.8281 4.6875H1.17188C0.503438 4.6875 0 5.25008 0 5.70312Z",
    fill: "#7663EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5469 15.3125C20.5469 15.8617 21.1046 16.4844 21.6406 16.4844H31.1719C32.7605 16.4844 32.8138 14.0625 30.9375 14.0625H22.0313C21.1869 14.0625 20.5469 14.5309 20.5469 15.3125Z",
    fill: "#7663EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8906 29.375C12.8906 30.0752 13.4947 30.625 14.2188 30.625H19.9219C21.22 30.625 21.5177 29.109 20.7959 28.5009C20.6209 28.3534 20.2361 28.2031 19.9219 28.2031H14.1406C13.3528 28.2031 12.8906 28.9495 12.8906 29.375Z",
    fill: "#7663EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8906 10.5469C12.8906 11.1986 13.4552 11.7969 14.1406 11.7969H19.9219C21.5909 11.7969 21.5909 9.375 19.9219 9.375H14.2187C13.8814 9.375 13.487 9.54086 13.2993 9.70555C13.1498 9.83656 12.8906 10.3167 12.8906 10.5469Z",
    fill: "#7663EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4835 24.5312C16.4835 25.1168 16.4381 25.2151 16.9295 25.6478C17.1673 25.8572 17.471 25.9375 17.8898 25.9375H23.2804C25.241 25.9375 25.0742 23.5156 23.5148 23.5156H17.6554C17.0515 23.5156 16.4835 23.9688 16.4835 24.5312Z",
    fill: "#7663EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.375 20C19.375 20.6249 19.904 21.1719 20.5469 21.1719H26.6406C27.9684 21.1719 27.9684 18.8281 26.6406 18.8281H20.5469C19.904 18.8281 19.375 19.3751 19.375 20Z",
    fill: "#7663EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectAcs);
export default __webpack_public_path__ + "static/media/project-acs.808de213571922673d1e7fdff63c59bc.svg";
export { ForwardRef as ReactComponent };